import React from 'react'
import {Select} from "antd"

const {Option} = Select

const SelectSearch = (props) => {
    const {listSelect, name, value, label, loading, disable = false, mode = '', clear = false, placeholder = ''} = props

    const _handleChangeSelect = (value) => {
        props.onChange(name, value)
    }

    return (
        <div className="InputSearch">
            <div className="font-weight-500 LabelFilter mb-1">{label}</div>

            <Select
                style={{width: '100%'}}
                disabled={disable}
                defaultValue=""
                value={value}
                loading={loading}
                onChange={_handleChangeSelect}
                mode={mode ? mode : null}
                allowClear={clear}
                placeholder={placeholder}
                filterOption={(input, option) => (option.value.toLowerCase() ?? '').includes(input.toLowerCase())}
                showSearch
            >
                {
                    listSelect.map(item => {
                        return <Option value={item.value} key={item.value}>{item.name}</Option>
                    })
                }
            </Select>
        </div>
    )
}

export default SelectSearch
